<template>
    <div class="float-left col text-muted p-item mb-2">
        <small>{{ control.name }}</small><br>
        <div v-for="(unit, index) in control.units" :key="`u-${index}`">
            <b class="added" v-if="unit.status == 'NEW' || unit.status == 'UPDATE'">{{ unit.value }}</b>
            <b class="deleted" >{{ unit.old }}</b>
        </div>
    </div>
</template>

<script>
export default {
    name: 'AuditNoteBilling',

    props: {
        control: Object
    }
}
</script>

<style scoped>
.deleted {
    color: red !important;
}
.added {
    color: green !important;
}
.b-2 {
    border: 2px solid !important;
}
</style>